export default __webpack_public_path__ + "static/media/google-play-white.31a74ef8.png";